import {Link} from 'react-router-dom';

function Footer() {
    const navigation = [
        { name: 'Home', href: '/' },
        { name: 'Product', href: '/product' },
        { name: 'Virtual Walkthrough', href: '/virtual-walkthrough' },
        { name: '3D Renderings', href: '/renderings' },
        { name: 'Pricing', href: '/pricing' },
        { name: 'Contact', href: '/contact' },
    ];

    const serviceCategories = [
        {
            title: 'Virtual Tours',
            services: [
                { name: '3D Virtual Tours', href: '/virtual-walkthrough' },
                { name: 'Interactive Walkthroughs', href: '/virtual-walkthrough' },
                { name: 'Virtual Reality Tours', href: '/virtual-walkthrough' },
                { name: 'Virtual Staging', href: '/virtual-walkthrough' }
            ]
        },
        {
            title: 'Design Services',
            services: [
                { name: 'Event Space Design', href: '/product' },
                { name: 'Space Planning', href: '/product' },
                { name: 'Design Consultation', href: '/product' }
            ]
        },
        {
            title: '3D Visualization',
            services: [
                { name: 'Architectural Visualization', href: '/renderings' },
                { name: 'Custom 3D Modeling', href: '/renderings' },
                { name: 'Real-time 3D Rendering', href: '/renderings' }
            ]
        }
    ];

    return (
        <footer className="bg-gray-50">
            <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                <nav className="flex flex-wrap justify-center space-x-6 mb-8">
                    {navigation.map((item) => (
                        <Link
                            key={item.name}
                            to={item.href}
                            className="text-gray-500 hover:text-gray-700 py-2"
                        >
                            {item.name}
                        </Link>
                    ))}
                </nav>
                
                <div className="border-t border-gray-200 pt-8">
                    <div className="flex flex-col md:flex-row items-center md:items-start gap-8 mb-8">
                        <div className="text-center md:text-left md:w-1/4">
                            <Link to="/" className="inline-block mb-4">
                                <img 
                                    src={`${process.env.PUBLIC_URL}/logo300.png`}
                                    alt="vidi3D Logo"
                                    className="h-20"
                                />
                            </Link>
                            <p className="text-gray-600 text-sm">
                                Transforming spaces into immersive digital experiences. Experience your space in a whole new dimension.
                            </p>
                        </div>
                        <div className="text-center md:text-left md:w-1/4">
                        </div>
                        
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:w-1/2">
                            {serviceCategories.map((category) => (
                                <div key={category.title}>
                                    <h3 className="text-sm font-semibold text-gray-700 mb-4">{category.title}</h3>
                                    <ul className="space-y-3">
                                        {category.services.map((service) => (
                                            <li key={service.name}>
                                                <Link
                                                    to={service.href}
                                                    className="text-sm text-gray-500 hover:text-gray-700"
                                                >
                                                    {service.name}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="border-t border-gray-200"></div>
                </div>

                <div className="flex justify-between items-center text-sm text-gray-500 mt-8">
                    <div>
                        <Link to="/privacy-policy" className="hover:text-brand">Privacy Policy</Link>
                        <span className="mx-2">|</span>
                        <Link to="/terms-of-service" className="hover:text-brand">Terms of Service</Link>
                        <span className="mx-2">|</span>
                        <Link to="/copyright" className="hover:text-brand">Copyright Policy</Link>
                    </div>
                    <div>
                        © {new Date().getFullYear()} vidi3D. All rights reserved.
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
